/* Contrôles ligne panier COMPLÉMENT (drawer + /cart) — dropdowns custom (pattern Balto).
   Markup : snippets/cart-subscription-freq.liquid.
   - Pots : swap de variante (remove + add en conservant le selling_plan).
   - Abo  : activer (selling_plan mensuel) / changer la fréquence / retirer (selling_plan null).
   Tout via /cart/change.js & /cart/add.js, puis refresh (reload sur /cart, in-place dans le drawer). */
(function () {
  'use strict';
  if (window.__cartFreqInit) return;
  window.__cartFreqInit = true;

  function refresh() {
    if (document.querySelector('.xo-main-cart')) { window.location.reload(); return Promise.resolve(); }
    if (window.JPCart && (window.JPCart.refreshDrawerInPlace || window.JPCart.refreshAndOpenDrawer)) {
      return (window.JPCart.refreshDrawerInPlace || window.JPCart.refreshAndOpenDrawer)();
    }
    window.location.reload();
    return Promise.resolve();
  }

  function busy(wrap, on) { if (wrap) wrap.classList.toggle('is-loading', on); }

  function months(name) {
    var m = (name || '').match(/(\d+)\s*mois/i);
    if (m) return parseInt(m[1], 10);
    return /mois/i.test(name) ? 1 : 99;
  }
  // Trie les options de fréquence 1 / 2 / 3 mois (la liste pots reste en ordre de variante)
  function sortFreq(ctl) {
    var list = ctl.querySelector('[data-cart-freq-list]');
    if (!list || list.__cfSorted) return;
    list.__cfSorted = true;
    var opts = [].slice.call(list.querySelectorAll('.cart-freq__opt'));
    opts.sort(function (a, b) { return months(a.textContent) - months(b.textContent); });
    opts.forEach(function (o) { list.appendChild(o); });
  }

  function openCtl(ctl, isOpen) {
    var list = ctl.querySelector('[data-cart-ctl-list]');
    var toggle = ctl.querySelector('[data-cart-ctl-toggle]');
    if (isOpen && ctl.hasAttribute('data-cart-freq')) sortFreq(ctl);
    ctl.classList.toggle('is-open', isOpen);
    if (list) list.hidden = !isOpen;
    if (toggle) toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }
  function closeAll(except) {
    document.querySelectorAll('.cart-ctl.is-open').forEach(function (c) { if (c !== except) openCtl(c, false); });
  }

  // Change le selling_plan d'une ligne (id de plan, ou null = achat unique)
  function changePlan(key, plan, loadingEl) {
    busy(loadingEl, true);
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, selling_plan: plan })
    }).then(function (r) { return r.json(); }).then(refresh)
      .catch(function (e) { console.error('[cart-ctl] plan', e); busy(loadingEl, false); });
  }

  // Swap de variante (Nombre de pots) en conservant l'abonnement éventuel
  function swapVariant(key, variantId, loadingEl) {
    busy(loadingEl, true);
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var line = cart.items.filter(function (i) { return i.key === key; })[0];
      var plan = line && line.selling_plan_allocation ? line.selling_plan_allocation.selling_plan.id : null;
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () {
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1, selling_plan: plan })
        });
      });
    }).then(refresh).catch(function (e) { console.error('[cart-ctl] swap', e); busy(loadingEl, false); });
  }

  document.addEventListener('click', function (e) {
    // Toggle d'un dropdown
    var toggle = e.target.closest && e.target.closest('[data-cart-ctl-toggle]');
    if (toggle) {
      e.preventDefault();
      var ctl = toggle.closest('.cart-ctl');
      var willOpen = !ctl.classList.contains('is-open');
      closeAll(ctl);
      openCtl(ctl, willOpen);
      return;
    }

    // Option « Nombre de pots » → swap variante
    var potOpt = e.target.closest && e.target.closest('.cart-pots__opt');
    if (potOpt) {
      var potWrap = potOpt.closest('[data-cart-pots]');
      if (!potWrap || potWrap.classList.contains('is-loading')) return;
      openCtl(potWrap, false);
      swapVariant(potWrap.getAttribute('data-line-key'), potOpt.getAttribute('data-variant-id'), potWrap);
      return;
    }

    // Option fréquence → change selling_plan
    var freqOpt = e.target.closest && e.target.closest('.cart-freq__opt');
    if (freqOpt) {
      var freqWrap = freqOpt.closest('[data-cart-freq]');
      if (!freqWrap || freqWrap.classList.contains('is-loading')) return;
      openCtl(freqWrap, false);
      changePlan(freqWrap.getAttribute('data-line-key'), freqOpt.getAttribute('data-value'), freqWrap);
      return;
    }

    // Activer l'abonnement (plan mensuel par défaut)
    var activate = e.target.closest && e.target.closest('[data-cart-sub-activate]');
    if (activate) {
      if (activate.classList.contains('is-loading')) return;
      activate.classList.add('is-loading');
      changePlan(activate.getAttribute('data-line-key'), activate.getAttribute('data-plan'), activate);
      return;
    }

    // Retirer l'abonnement → achat unique
    var cancel = e.target.closest && e.target.closest('[data-cart-sub-cancel]');
    if (cancel) {
      if (cancel.classList.contains('is-loading')) return;
      cancel.classList.add('is-loading');
      changePlan(cancel.getAttribute('data-line-key'), null, cancel);
      return;
    }

    // Clic en dehors → fermer
    if (!e.target.closest('.cart-ctl')) closeAll(null);
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
})();
